import {Card, Col, Empty, Row} from "antd";
import {useEffect, useState} from "react";
import {Button, FontAwesomeIcon, Loading} from "../../../components";
import {Link, useParams} from "react-router-dom";
import {apiError, handleRequest} from "../../../utils";
import {ticketApi} from "../../../api";
import DOMPurify from "dompurify";
import {TicketComment} from "../components";


function TicketDetail()
{
    const {id} = useParams();

    const [loading, setLoading] = useState(true);

    const [errorLoad, setErrorLoad] = useState(false);

    const [ticket, setTicket] = useState({});

    const TitleComponent = () => {
        return <><b>NỘI DUNG YÊU CẦU</b> - <span className={'color-red'}>{ticket.title}</span></>
    }

    const eventsHandler = {
        load: async () => {

            let [error, response] = await handleRequest(ticketApi.detail({
                id: id
            }));

            let message = apiError(`Load ticket thất bại`, error, response);

            if (!message)
            {
                setTicket(response.data);
                setErrorLoad(false)
            }
            else
            {
                setErrorLoad(true);
            }

            setLoading(false);
        },
        isRead: () => {
            ticketApi.isRead(id)
        }
    }

    useEffect(() => {
        eventsHandler.load().then(() => eventsHandler.isRead())
    }, [id])

    if(loading) {
        return (
            <div className="container">
                <Loading/>
            </div>
        )
    }

    if(errorLoad) {
        return (
            <div className="container">
                <Empty description={<span>Không có ticket</span>}><Button to={'/ticket'}>Quay lại danh sách ticket</Button></Empty>
            </div>
        )
    }

    return (
        <>
            <div className="container d-block">
                <div className="content pd-2" style={{overflow: 'auto'}}>
                    <p className={'mb-3'}><Link to={'/ticket'}><FontAwesomeIcon icon="fa-duotone fa-solid fa-arrow-left-long" /> Quay lại danh sách ticket</Link></p>
                    <Row gutter={16} className="mb-2">
                        <Col className="gutter-row" span={4}>
                            <Card>
                                <p>Mã câu hỏi</p>
                                <b>TK{ticket.id}</b>
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={4}>
                            <Card>
                                <p>Dịch vụ</p>
                                {ticket.serviceName}
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={4}>
                            <Card>
                                <p>Yêu cầu</p>
                                {ticket.typeName}
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={4}>
                            <Card>
                                <p>Trạng thái</p>
                                {ticket.status.label}
                            </Card>
                        </Col>
                        <Col className="gutter-row" span={4}>
                            <Card>
                                <p>Ngày tạo</p>
                                {ticket.created}
                            </Card>
                        </Col>
                    </Row>
                    <Card title={<TitleComponent />}>
                        <div style={{wordBreak : 'break-all'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ticket.content) }} />
                        <hr />
                        <p className={'mb-1'}><b>File Đính kèm</b></p>
                        {ticket.files && ticket.files.map((f, index) => (<p className={'mb-1'}><a href={f.filePath} target='_blank'>{f.name}</a></p>))}
                    </Card>
                    <TicketComment ticket={ticket} />
                </div>
            </div>
        </>
    )
}

export default TicketDetail;